import { render } from "./PersonalizationWidget.vue?vue&type=template&id=9ef33c6a"
import script from "./PersonalizationWidget.vue?vue&type=script&lang=js"
export * from "./PersonalizationWidget.vue?vue&type=script&lang=js"

import "./PersonalizationWidget.vue?vue&type=style&index=0&id=9ef33c6a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__